/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareHomeHealthLookupsResponse } from './MatrixCareHomeHealthLookupsResponse';
import {
    MatrixCareHomeHealthLookupsResponseFromJSON,
    MatrixCareHomeHealthLookupsResponseFromJSONTyped,
    MatrixCareHomeHealthLookupsResponseToJSON,
    MatrixCareHomeHealthLookupsResponseToJSONTyped,
} from './MatrixCareHomeHealthLookupsResponse';

/**
 * 
 * @export
 * @interface GetMatrixCareHomeHealthLookups200Response
 */
export interface GetMatrixCareHomeHealthLookups200Response {
    /**
     * 
     */
    data?: MatrixCareHomeHealthLookupsResponse;
}

/**
 * Check if a given object implements the GetMatrixCareHomeHealthLookups200Response interface.
 */
export function instanceOfGetMatrixCareHomeHealthLookups200Response(value: object): value is GetMatrixCareHomeHealthLookups200Response {
    return true;
}

export function GetMatrixCareHomeHealthLookups200ResponseFromJSON(json: any): GetMatrixCareHomeHealthLookups200Response {
    return GetMatrixCareHomeHealthLookups200ResponseFromJSONTyped(json, false);
}

export function GetMatrixCareHomeHealthLookups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMatrixCareHomeHealthLookups200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MatrixCareHomeHealthLookupsResponseFromJSON(json['data']),
    };
}

export function GetMatrixCareHomeHealthLookups200ResponseToJSON(json: any): GetMatrixCareHomeHealthLookups200Response {
    return GetMatrixCareHomeHealthLookups200ResponseToJSONTyped(json, false);
}

export function GetMatrixCareHomeHealthLookups200ResponseToJSONTyped(value?: GetMatrixCareHomeHealthLookups200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MatrixCareHomeHealthLookupsResponseToJSON(value['data']),
    };
}

